module.exports = __webpack_public_path__ + "img/close.fe4477e7.svg";